import { Container } from "react-bootstrap";
import Header from "../component/Header";



function Layout({ children }) {
    return (
      <>
        <Header/>
        <Container className="px-4 mx-auto" fluid='xxl' >{children}</Container>
        
      </>
    );
  }
  

export default Layout;
